import { render, staticRenderFns } from "./GlpSA.vue?vue&type=template&id=47718ed5&"
import script from "./GlpSA.vue?vue&type=script&lang=js&"
export * from "./GlpSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports